import React, { useMemo } from 'react';
import { Checkbox, MenuItem, TextField, Typography, WithInfoIcon } from 'seagull';
import { getAllAutoApprovalDays, getAutoApprovalRange, isAmendmentAutoApprovalValid } from "../../../business-logic/amendmentsAutoApproval";
import { numberAndUnit } from "../../../infra/utils";
import styles from "./ApprovalMethodNoticePeriodField.module.scss";
export function validateApprovalMethodNoticePeriod(enabled, noticePeriod) {
  return !enabled || !!noticePeriod && isAmendmentAutoApprovalValid(noticePeriod);
}
export const ApprovalMethodNoticePeriodField = props => {
  const {
    info,
    text,
    testid,
    enabled,
    noticePeriod,
    onToggle,
    onChangePeriod
  } = props;
  const {
    minDays,
    maxDays
  } = getAutoApprovalRange();
  const dayOptions = useMemo(() => getAllAutoApprovalDays().map(value => ({
    value,
    text: numberAndUnit(value, 'day'),
    testid: "".concat(testid, "-period-").concat(value)
  })), []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.toggleBlock
  }, /*#__PURE__*/React.createElement(WithInfoIcon, {
    info: info
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: enabled,
    onChange: e => onToggle(e.currentTarget.checked),
    "data-testid": "".concat(testid, "-toggle")
  }, /*#__PURE__*/React.createElement(Typography, null, text)))), enabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.periodInput
  }, /*#__PURE__*/React.createElement(TextField, {
    select: true,
    label: "Notice period",
    value: noticePeriod,
    menuMaxHeight: 220,
    testid: "".concat(testid, "-period"),
    onChange: e => onChangePeriod(Number.parseInt(e.target.value))
  }, dayOptions.map(_ref => {
    let {
      value,
      text,
      testid
    } = _ref;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: value,
      value: '' + value,
      "data-testid": testid
    }, text);
  }))), !validateApprovalMethodNoticePeriod(enabled, noticePeriod) && /*#__PURE__*/React.createElement(Typography, {
    skin: "error",
    variant: "paragraph2",
    "data-testid": "".concat(testid, "-error")
  }, "Notice period must be between ", minDays, " and ", maxDays, " days")));
};